import { UnresolvedContactListPage } from "@/features/contact/pages/UnresolvedContactList";
import React from "react";

const UnresolvedContactList = () => {
  return <UnresolvedContactListPage />;
};

export default UnresolvedContactList;
